import localStorage from 'store'

export default {
  user: localStorage.get('user') || {},
  token: localStorage.get('token') || '',
  survey: [],
  form: [],
  currentCase: [],
  cases: [
    {
      slug: 'benefits_of_space_tour',
      title: 'Benefits of Space Tour',
      client: 'nasa',
      hero: '/static/images/case-studies/nasa-benefits/nasa-benefits-hero.jpg',
      thumb: '/static/images/case-studies/nasa-benefits/nasa-benefits_01.jpg',
      logo: '/static/svg/client-logos/NASA.svg',
      desc: '<p>Over 700 events and a decade of service for aerospace pioneer NASA</p>',
      body: '<p>The NASA Benefits of Space Tour ran from 1999 to 2009 with a major remodel of the trailer and the scope of the display in 2005. The goal of the tour was publicity and public outreach. Visiting schools and community events for a decade it attended nearly 500 events and reached just under one-million people. This tour easily achieved it’s goal of inspiring an entire generation to keep their eye’s on the skies.</p><p>For both iterations of the tour the trailer was split into two sections (front and back). From 1999 to 2005 the front of the trailer was a museum style presentation of about a dozen products and inventions that were a direct result of space exploration. This automated presentation would spotlight object around the room and narrate the history and uses for the individual product. In its second iteration the the front of the trailer was changed to a state of the art virtual mars atmosphere/experience with interactive floors and walls that would simulate gravity and conditions on the planet of Mars.</p><p>For both iterations of the tour the back half of the trailer had a large 80 seat Bose surround sound theater where short films showcasing space exploration and the International Space Station were shown. Crowds would be let into the trailer 80 at a time, and while the crowd outside waited they were entertained with trivia and prizes from NASA Volunteers. These volunteers ranged from scientists to astronauts and dramatically added to impact of the event on its target audience. In addition to the already out of this world experience; for a number of years the tour was one of only two places in the world where an actual moon rock was on display to the public making the NASA Benefit of Space Tour a truly unique endeavor.</p>',
      images: [
        {
          id: 1,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_01.jpg'
        },
        {
          id: 2,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_02.jpg'
        },
        {
          id: 3,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_03.jpg'
        },
        {
          id: 4,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_04.jpg'
        },
        {
          id: 5,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_05.jpg'
        },
        {
          id: 6,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_06.jpg'
        },
        {
          id: 7,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_07.jpg'
        },
        {
          id: 8,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_08.jpg'
        },
        {
          id: 9,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_09.jpg'
        },
        {
          id: 10,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_10.jpg'
        },
        {
          id: 11,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_11.jpg'
        },
        {
          id: 12,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_12.jpg'
        },
        {
          id: 13,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_13.jpg'
        },
        {
          id: 14,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_14.jpg'
        },
        {
          id: 15,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_15.jpg'
        },
        {
          id: 16,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_16.jpg'
        },
        {
          id: 17,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_17.jpg'
        },
        {
          id: 18,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_18.jpg'
        },
        {
          id: 19,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_19.jpg'
        },
        {
          id: 20,
          image: '/static/images/case-studies/nasa-benefits/nasa-benefits_20.jpg'
        }
      ]
    },
    {
      slug: 'da_vinci_surgical_robot',
      title: 'da Vinci Surgical Robot',
      client: 'intuitive surgical',
      hero: '/static/images/case-studies/is-da-vinci/is-da-vinci-hero.jpg',
      thumb: '/static/images/case-studies/is-da-vinci/is-da-vinci_01.jpg',
      logo: '/static/svg/client-logos/IntuitiveSurgical.svg',
      desc: '<p>4,200 events since 2004 for medical innovator Intuitive Surgical</p>',
      body: '<p>As PMG’s longest standing client Intuitive Surgical has seen first hand the value of experiential marketing. Starting in 2000 with the launch of the original Davinci Surgical System PMG operated a nationwide tour featuring a double slide-out trailer and specializing in surgeon education to help prepare the world for the new wave of robotic surgery.</p><p>Originally an educational tour, robotic surgery generated a _ of attention and in subsequent years the tour expanded dramatically. At first Intuitive had PMG add a second vehicle capable of delivering and setting up a pop-up trade show-show style demonstration. This could be installed and ready for use in a hospital, restaurant, or convention center within an hour or two of arrival. The program and new type of hospital sales demo was immensely successful and by 2015 had expanded to include a total of 14 concurrently operating tours.</p><p>The idea of a fleet of mobile sales demonstrations each attending up to 5 events per week has driven sales in an unprecedented way. The ability of PMG to manage such a large scale program while maintaining a professional and efficient tour schedule is why Intuitive surgical has chosen PMG as their tour management company for nearly 2 decades and are on-track to complete our 20,000th event for Intuitive Surgical early in 2019.</p><p>The tour has transformed to provide a live demonstration to all kinds of venues. It has attended thousands of hospitals and private venues for sales demonstrations. In addition the tour visits a number of special events and training summits. PMG has hosted Intuitive Surgical events at a variety of venues ranging from a local 5K for charity to The Superbowl. This innovative experiential marketing technique has changed the way sales, public outreach, and educational training is handled throughout the surgical industry.</p>',
      images: [
        {
          id: 1,
          image: '/static/images/case-studies/is-da-vinci/is-da-vinci_01.jpg'
        },
        {
          id: 2,
          image: '/static/images/case-studies/is-da-vinci/is-da-vinci_02.jpg'
        },
        {
          id: 3,
          image: '/static/images/case-studies/is-da-vinci/is-da-vinci_03.jpg'
        },
        {
          id: 4,
          image: '/static/images/case-studies/is-da-vinci/is-da-vinci_04.jpg'
        },
        {
          id: 5,
          image: '/static/images/case-studies/is-da-vinci/is-da-vinci_05.jpg'
        },
        {
          id: 6,
          image: '/static/images/case-studies/is-da-vinci/is-da-vinci_06.jpg'
        },
        {
          id: 7,
          image: '/static/images/case-studies/is-da-vinci/is-da-vinci_07.jpg'
        },
        {
          id: 8,
          image: '/static/images/case-studies/is-da-vinci/is-da-vinci_08.jpg'
        }
      ]
    },
    {
      slug: 'pristina_3d',
      title: 'Pristina 3D',
      client: 'general electric',
      hero: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d-hero.jpg',
      thumb: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_01.jpg',
      logo: '/static/svg/client-logos/GE.svg',
      desc: '<p>GE Healthcare gains $7 in sales for each $1 spent on PMG marketing tour</p>',
      body: '<p>In 2017 The Women\'s Health Division chose PMG to launch and promote their revolutionary 4D Prestina Mammography Machine and Sensory Suite. This tour was two part with a full sized trailer display encompassing the Pristina and a select group of other GE Healthcare related machinery. The other portion of the tour was a mobile trade show to take place inside of Hotels and convention centers at each stop. All properties and display items were transported aboard the trailer and unloaded and set-up inside the meeting space to provide a mobile trade-show focusing on GE products related to Mammography (software suits, SenoIris workstations, Invenia & Logiq Ultrasound, etc.). Each tour stop was attended by hospital administrators as well as doctors and surgeons interested in learning more about the technology on display. The tour was so successful that after the initial run subsequent events were and are currently being added to the schedule.</p><p>What made this tour so spectacular is the transformation of the inside of the trailer from a sterile lab environment into a spa setting. The design team at PMG worked closely with the staff of GE’s Women\'s Health to bring their vision to life. Attendee’s of the events are so blown away by the spa setting and atmosphere that was created that many requests have been made of the same design team to consult on their own imaging space.</p><p>The focus of the Pristina system was to take the discomfort and awkward lab feeling away from the associated medical procedures. GE’s science backs-up the correlation between a comfortable atmosphere and successful/effective screenings, and the trailer was designed around getting that point across.</p>',
      images: [
        {
          id: 1,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_01.jpg'
        },
        {
          id: 2,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_02.jpg'
        },
        {
          id: 3,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_03.jpg'
        },
        {
          id: 4,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_04.jpg'
        },
        {
          id: 5,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_05.jpg'
        },
        {
          id: 6,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_06.jpg'
        },
        {
          id: 7,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_07.jpg'
        },
        {
          id: 8,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_08.jpg'
        },
        {
          id: 9,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_09.jpg'
        },
        {
          id: 10,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_10.jpg'
        },
        {
          id: 11,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_11.jpg'
        },
        {
          id: 12,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_12.jpg'
        },
        {
          id: 13,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_13.jpg'
        },
        {
          id: 14,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_14.jpg'
        },
        {
          id: 15,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_15.jpg'
        },
        {
          id: 16,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_16.jpg'
        },
        {
          id: 17,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_17.jpg'
        },
        {
          id: 18,
          image: '/static/images/case-studies/ge-pristina-3d/ge-pristina-3d_18.jpg'
        }
      ]
    },
    {
      slug: 'embraer_erj190',
      title: 'Embraer ERJ190',
      client: 'embraer',
      hero: '/static/images/case-studies/embraer-ej190/embraer-ej190-hero.jpg',
      thumb: '/static/images/case-studies/embraer-ej190/embraer-ej190_06.jpg',
      logo: '/static/svg/client-logos/Embraer.svg',
      desc: '<p>50 marketing tour events in 24 months for aviation icon Embraer</p>',
      body: '<p>ERJ190 - In 2000 and 2001 Promotional Management Group teamed up with Embraer aircraft manufacturers to help launch and promote the sale of their new narrow-body medium-range twin-engine jet airliner. This was a truly unique tour aimed at bringing the experience of stepping onto a ERJ190 directly to Airlines throughout North America.</p><p>The tour consisted of a mockup of the fuselage built into a large mobile trailer at the heart of the display. This three vehicle tour was made up of the main Fuselage as well as a full sized motor coach specially designed to emulate the feeling of a high-end conference room. This mobile meeting space gave the client an area to negotiate and discuss the terms of sales on site. The third member of the tour was a “chase vehicle” containing large display pieces used to wow potential customers and illicit interest in the ERJ 190.</p>',
      images: [
        {
          id: 1,
          image: '/static/images/case-studies/embraer-ej190/embraer-ej190_01.jpg'
        },
        {
          id: 2,
          image: '/static/images/case-studies/embraer-ej190/embraer-ej190_02.jpg'
        },
        {
          id: 3,
          image: '/static/images/case-studies/embraer-ej190/embraer-ej190_03.jpg'
        },
        {
          id: 4,
          image: '/static/images/case-studies/embraer-ej190/embraer-ej190_04.jpg'
        },
        {
          id: 5,
          image: '/static/images/case-studies/embraer-ej190/embraer-ej190_05.jpg'
        },
        {
          id: 6,
          image: '/static/images/case-studies/embraer-ej190/embraer-ej190_06.jpg'
        },
        {
          id: 7,
          image: '/static/images/case-studies/embraer-ej190/embraer-ej190_07.jpg'
        }
      ]
    },
    {
      slug: 'innovation_delivered',
      title: 'Innovation: Delivered',
      client: 'covidien',
      hero: '/static/images/case-studies/covidien/covidien-hero.jpg',
      thumb: '/static/images/case-studies/covidien/covidien_01.jpg',
      logo: '/static/svg/client-logos/Covidien.svg',
      desc: '<p>120 events in 24 months for healthcare products provider Covidien</p>',
      body: '<p>In 2009 PMG was chosen to design, develop, manage and operate the Innovation: Delivered Tour. This tour featured hands-on workshops where surgeons, residents and hospital administrators were introduced and trained to use the new SILS Port Multiple Instrument Access Device. When parked the trailer expands into a clinical training area, conference room, and 5 independent operating room stations that accommodate 10 surgeons simultaneously. The goal of the tour was to visit hospitals, trade shows, and medical conferences “[Bringing] these crucial tools and opportunities directly to surgeons.” the tour was an immense success and would continue for 3 years to provide Covidien a valuable platform for everything from education to sales initiatives.</p><p>The demonstrations of the SILS Port system allowed a hands-on opportunity to generate interest in a system designed to dramatically reduce the risk and scarring associated with traditional surgery.</p>',
      images: [
        {
          id: 1,
          image: '/static/images/case-studies/covidien/covidien_01.jpg'
        },
        {
          id: 2,
          image: '/static/images/case-studies/covidien/covidien_02.jpg'
        },
        {
          id: 3,
          image: '/static/images/case-studies/covidien/covidien_03.jpg'
        },
        {
          id: 4,
          image: '/static/images/case-studies/covidien/covidien_04.jpg'
        },
        {
          id: 5,
          image: '/static/images/case-studies/covidien/covidien_05.jpg'
        },
        {
          id: 6,
          image: '/static/images/case-studies/covidien/covidien_06.jpg'
        },
        {
          id: 7,
          image: '/static/images/case-studies/covidien/covidien_07.jpg'
        },
        {
          id: 8,
          image: '/static/images/case-studies/covidien/covidien_08.jpg'
        },
        {
          id: 9,
          image: '/static/images/case-studies/covidien/covidien_09.jpg'
        },
        {
          id: 10,
          image: '/static/images/case-studies/covidien/covidien_10.jpg'
        },
        {
          id: 11,
          image: '/static/images/case-studies/covidien/covidien_11.jpg'
        },
        {
          id: 12,
          image: '/static/images/case-studies/covidien/covidien_12.jpg'
        },
        {
          id: 13,
          image: '/static/images/case-studies/covidien/covidien_13.jpg'
        },
        {
          id: 14,
          image: '/static/images/case-studies/covidien/covidien_14.jpg'
        },
        {
          id: 15,
          image: '/static/images/case-studies/covidien/covidien_15.jpg'
        }
      ]
    },
    {
      slug: 'brand_revival_tour',
      title: 'Brand Revival Tour',
      client: 'indian motorcycles',
      hero: '/static/images/case-studies/im-brand-revival/im-brand-revival-hero.jpg',
      thumb: '/static/images/case-studies/im-brand-revival/im-brand-revival_01.jpg',
      logo: '/static/svg/client-logos/IndianMotorcycle.svg',
      desc: '<p>20 world tour events for iconic motorsports brand Indian Motorcycles</p>',
      body: '<p>In 2002 and 2003 Indian Motorcycle launched a new campaign to relaunch the formerly retired Indian Motorcycle stylings and label themselves as America’s First Motorcycle. The tour consisted of a Large Trailer and enclosed area where Indian antiques ranging from original signs to vintage motorcycles were on display to the public. The trailer contained a historical museum educating on the history of the brand, as well as a Museum containing rare original Indian Motorcycles. In addition the trailer had a dedicated retail store front where event specific gear was sold to eager fans. Each event partnered with local Indian Dealerships to provide a fleet of bikes for potential customers to test drive on-site.</p><p>This brand revival tour was focused on restoring brand recognition. The entire display centered around generating enthusiasm for Indian Motorcycles new line-up in direct competition with the other large names in the industry. The use of absolutely enormous logo placement and signage created an incredible pull on potential customers and attendance was substantially increased from the simple booths and tents used in prior years at the same events.</p><p>This was a three vehicle tour consisting of one large tractor trailer as the center of the display. An additional truck was used to transport the enormous signs and armory of attention grabbing branding material.</p>',
      images: [
        {
          id: 1,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_01.jpg'
        },
        {
          id: 2,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_02.jpg'
        },
        {
          id: 3,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_03.jpg'
        },
        {
          id: 4,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_04.jpg'
        },
        {
          id: 5,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_05.jpg'
        },
        {
          id: 6,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_06.jpg'
        },
        {
          id: 7,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_07.jpg'
        },
        {
          id: 8,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_08.jpg'
        },
        {
          id: 9,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_09.jpg'
        },
        {
          id: 10,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_10.jpg'
        },
        {
          id: 11,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_11.jpg'
        },
        {
          id: 12,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_12.jpg'
        },
        {
          id: 13,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_13.jpg'
        },
        {
          id: 14,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_14.jpg'
        },
        {
          id: 15,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_15.jpg'
        },
        {
          id: 16,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_16.jpg'
        },
        {
          id: 17,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_17.jpg'
        },
        {
          id: 18,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_18.jpg'
        },
        {
          id: 19,
          image: '/static/images/case-studies/im-brand-revival/im-brand-revival_19.jpg'
        }
      ]
    },
    {
      slug: 'ready_to_rock_tour',
      title: 'Ready to Rock Tour',
      client: 'general electric',
      hero: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock-hero.jpg',
      thumb: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_01.jpg',
      logo: '/static/svg/client-logos/GE.svg',
      desc: '<p>GE Healthcare gains $7 in sales for each $1 spent on PMG marketing tour</p>',
      body: '<p>In 2012 GE and PMG partnered again, this time to launch the Ready to Rock Tour. This tour was made up of one trailer with a double slide-out providing a massive demonstration space for GE’s exciting new technology; Plug and Play BioManufacturing with ReadyToProcess Equipment. The tour traveled to Pharmaceutical companies and research hospitals/institutes to demonstrate machinery capable of achieving a task that until then was only possible in a 40,000 square foot medical manufacturing lab.</p><p>The Plug and Play BioManufacturing with ReadyToProcess Equipment was capable of processing and producing small batch cell cultures for a fraction of the cost, in a fraction of the time, and with a minimal lab space footprint. By splitting the open-space double slide-out trailer into a presentation area and a demonstration area, it was obvious to everyone in attendance that the technology and processes on display were no longer reserved for giant industrial labs.</p>',
      images: [
        {
          id: 1,
          image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_01.jpg'
        },
        {
          id: 2,
          image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_02.jpg'
        },
        {
          id: 3,
          image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_03.jpg'
        },
        {
          id: 4,
          image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_04.jpg'
        },
        {
          id: 5,
          image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_05.jpg'
        },
        {
          id: 6,
          image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_06.jpg'
        },
        {
          id: 7,
          image: '/static/images/case-studies/ge-ready-to-rock/ge-ready-to-rock_07.jpg'
        }
      ]
    },
    {
      slug: 'mobile_education',
      title: 'Mobile Education, Therapy and Procedure Training',
      client: 'medtronic',
      hero: '/static/images/case-studies/medtronic-me/medtronic-me-hero.jpg',
      thumb: '/static/images/case-studies/medtronic-me/medtronic-me_01.jpg',
      logo: '/static/svg/client-logos/Medtronic.svg',
      desc: '<p>Over 600 events for therapeutic healthcare supplier Medtronic</p>',
      body: '<p>From 2005 to 2008 PMG partnered with Medtronic again for a tour targeting the education of cardiologists and hospital technicians in the implementation of Pacemaker leads and other Medtronic products. The goal was to educate medical staff on the positive impact of Medtronic\'s products in the battle against heart disease. The first year of the tour would prove so successful that the subsequent years would each see the expansion to an additional trailer on tour. Stepping from one, to two, to finally three concurrent tours is testament to how well experiential marketing can impact sales and aid in customer outreach and training.</p>',
      images: [
        {
          id: 1,
          image: '/static/images/case-studies/medtronic-me/medtronic-me_01.jpg'
        },
        {
          id: 2,
          image: '/static/images/case-studies/medtronic-me/medtronic-me_02.jpg'
        },
        {
          id: 3,
          image: '/static/images/case-studies/medtronic-me/medtronic-me_03.jpg'
        },
        {
          id: 4,
          image: '/static/images/case-studies/medtronic-me/medtronic-me_04.jpg'
        },
        {
          id: 5,
          image: '/static/images/case-studies/medtronic-me/medtronic-me_05.jpg'
        },
        {
          id: 6,
          image: '/static/images/case-studies/medtronic-me/medtronic-me_06.jpg'
        },
        {
          id: 7,
          image: '/static/images/case-studies/medtronic-me/medtronic-me_07.jpg'
        },
        {
          id: 8,
          image: '/static/images/case-studies/medtronic-me/medtronic-me_08.jpg'
        },
        {
          id: 9,
          image: '/static/images/case-studies/medtronic-me/medtronic-me_09.jpg'
        },
        {
          id: 10,
          image: '/static/images/case-studies/medtronic-me/medtronic-me_10.jpg'
        }
      ]
    },
    {
      slug: 'acceleration_now_tour',
      title: 'Acceleration Now Tour',
      client: 'ingersoll rand & trane',
      hero: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now-hero.jpg',
      thumb: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_01.jpg',
      logo: '/static/svg/client-logos/Trane.svg',
      desc: '<p>In 2014 Trane and PMG planned and executed an exciting tour launch of their new product lines</p>',
      body: '<p>In 2014 Trane and PMG planned and executed an exciting tour launch of their new product lines centering around marketing efficient and reliable products to building owners and contractors. With three trailers touring together, they visited 70 locations in 39 weeks and made a huge impact at every stop. It was described as “a rolling carnival of Trane products and technology.”</p><p>The centerpiece was a huge double slide-out trailer with an amazing AV experience and several product lines on display. The second trailer housed and transported additional commercial grade chillers and HVAC systems weighing in at several thousand pounds each. Guests were presented with a walk-up podium and ipad guided tour making each piece of equipment the star of a presentation. The final trailer was used for equipment that would otherwise be too large and heavy to attend the tour.</p><p>The three trailers carried large tents to host banquet areas outside of each venue. They also contained 15 interactive kiosks where technical details and fully animated demonstrations of addition pieces in a product line were made available. The most impactful part of the presentation combined a large enclosed tent with a rack of heavy winter parkas. The entire event took place in large parking lots (like the Rosebowl), where temperatures outside reach over 100 degrees. Despite the blistering heat outside, guests were invited to grab a parka and enter the tent for a presentation where the temperature was kept at nearly freezing by a Trane chiller, embodying the experiential marketing philosophy.</p><p>Each event provided drawings, food, and had a party like atmosphere that left potential customers feeling impressed and valued. The entire tour was considered an overwhelming success by everyone involved, and led to an additional tour (of smaller scale) when Ingersoll Rand launched an additional set of products a few years later.</p>',
      images: [
        {
          id: 1,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_01.jpg'
        },
        {
          id: 2,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_02.jpg'
        },
        {
          id: 3,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_03.jpg'
        },
        {
          id: 4,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_04.jpg'
        },
        {
          id: 5,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_05.jpg'
        },
        {
          id: 6,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_06.jpg'
        },
        {
          id: 7,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_07.jpg'
        },
        {
          id: 8,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_08.jpg'
        },
        {
          id: 9,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_09.jpg'
        },
        {
          id: 10,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_10.jpg'
        },
        {
          id: 11,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_11.jpg'
        },
        {
          id: 12,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_12.jpg'
        },
        {
          id: 13,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_13.jpg'
        },
        {
          id: 14,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_14.jpg'
        },
        {
          id: 15,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_15.jpg'
        },
        {
          id: 16,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_16.jpg'
        },
        {
          id: 17,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_17.jpg'
        },
        {
          id: 18,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_18.jpg'
        },
        {
          id: 19,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_19.jpg'
        },
        {
          id: 20,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_20.jpg'
        },
        {
          id: 21,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_21.jpg'
        },
        {
          id: 22,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_22.jpg'
        },
        {
          id: 23,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_23.jpg'
        },
        {
          id: 24,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_24.jpg'
        },
        {
          id: 25,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_25.jpg'
        },
        {
          id: 26,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_26.jpg'
        },
        {
          id: 27,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_27.jpg'
        },
        {
          id: 28,
          image: '/static/images/case-studies/trane-acceleration-now/trane-acceleration-now_28.jpg'
        }
      ]
    },
    {
      slug: 'medtronic_software_danek_spinal_tour',
      title: 'Medtronic Sofamor Danek Spinal Tour',
      client: 'medtronic',
      hero: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer-hero.jpg',
      thumb: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_01.jpg',
      logo: '/static/svg/client-logos/Medtronic.svg',
      desc: '<p>Over 600 events for therapeutic healthcare supplier Medtronic</p>',
      body: '<p>From 2002 to 2006 Promotional Management Group was asked to step in and take over the Medtronics Sofamor Danek Spinal Tour. After seeing the professionalism and attention to detail that PMG brought to all of their mobile tours; PMG was given the opportunity to assume management and operation of this two tour program. Each tour consisted of a single 53 foot trailer containing a simulated cadaveric lab used for training. This vehicle was accompanied by a large box truck used to transport cadavers used in the spinal surgery training lab.</p><p>The two tours mirrored each other on opposite sides of the United States visiting Hospitals, Universities and Medical Trade Shows. The sterile surgical environment was ideal for instructing surgeons in a hands on setting. This was PMG’s first experience in cadaveric labs and cemented them as the go-to mobile marketing company for medical education tours.</p>',
      images: [
        {
          id: 1,
          image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_01.jpg'
        },
        {
          id: 2,
          image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_02.jpg'
        },
        {
          id: 3,
          image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_03.jpg'
        },
        {
          id: 4,
          image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_04.jpg'
        },
        {
          id: 5,
          image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_05.jpg'
        },
        {
          id: 6,
          image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_06.jpg'
        },
        {
          id: 7,
          image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_07.jpg'
        },
        {
          id: 8,
          image: '/static/images/case-studies/medtronic-sofamer/medtronic-sofamer_08.jpg'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/state.js